import { FC, ReactNode, useCallback } from 'react'
import { useTranslation } from 'next-i18next'

import { useCustomIntercom } from 'hooks/common/intercom'

import space_styles from './BasicInformationSection.module.scss'

export type SpaceInfoLabel = {
  className: string
  isPermit: boolean
  text: string
  icon: string
  meta: string
}

type Props = {
  labels: SpaceInfoLabel[]
  showReportButton?: boolean
  children?: ReactNode
}

/** 基本情報セクション (設備ラベル一覧 + 問題報告ボタン)。 */
export const BasicInformationSection: FC<Props> = ({
  labels,
  showReportButton = true,
  children,
}) => {
  const { t } = useTranslation()

  const { openIntercomMessage } = useCustomIntercom()
  const handleOpenIntercom = useCallback(() => {
    openIntercomMessage(true)
  }, [openIntercomMessage])

  return (
    <section className={space_styles.basicInformationSection}>
      <div className={space_styles.basicInformationSectionHeading}>
        <h2 className={space_styles.basicInformationSectionHeadingTitle}>
          {t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.TITLE')}
        </h2>
        {showReportButton && (
          <button className={space_styles.report} onClick={handleOpenIntercom}>
            <img src="/warning_icon_blue.svg" alt="" height="13px" width="13px" />
            {t('SPACE_DETAIL.SECTION.BASIC_INFORMATION.REPORT_A_PROBLEM')}
          </button>
        )}
      </div>
      <ul className={space_styles.basicInformationLabels}>
        {labels.map((label, index) => (
          <li
            className={`${space_styles.basicInformationLabel} ${
              label.isPermit ? space_styles.enabled : space_styles.disabled
            }`}
            key={index}
          >
            <img
              className={space_styles.basicInformationLabelImage}
              src={label.icon}
              alt={label.meta}
              height="24px"
              width="24px"
            />
            <p className={space_styles.basicInformationLabelName}>{label.text}</p>
          </li>
        ))}
      </ul>
      {children}
    </section>
  )
}
